export default "__VITE_ASSET__3a593254__"